export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8783.108f5c7f.jpg";